import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import cart from './modules/cart'
import products from './modules/products'
import addresses from './modules/addresses'
import orders from './modules/orders'
import configs from './modules/config'
import plugins from './plugins'

Vue.use(Vuex)


const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    cart,
    products,
    addresses,
    orders,
    configs,
  },
  strict: debug,
  plugins
})



// WEBPACK FOOTER //
// ./src/store/index.js